module.exports = __webpack_public_path__ + "img/logo-hauseful.c373c231.svg";